import { addDoc, collection, doc, getDoc, getDocs, getFirestore, query, serverTimestamp, updateDoc, where, setDoc } from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import { CONT_COLLECTIONS } from "./collections";
import {
  normalizarDocumentoTributarioVenta,
  normalizarDocumentoTributarioCompra,
  crearRegistroTributario,
  validarDocumentoTributario,
  validarRegistroTributario,
} from "./tributarioModel";

const db = getFirestore(firebaseApp);
const cleanText = (value) => (value == null ? "" : String(value).trim());

export const registrarDocumentoTributarioVenta = async ({ rucEmpresa, empresaId, origen, comprobante, clienteRuc, clienteRazonSocial, subtotal, igv, total, tipoOperacion, documentoRelacionado, usuario }, transaction) => {
  const documento = normalizarDocumentoTributarioVenta({
    empresaId,
    rucEmpresa,
    comprobante,
    clienteRuc,
    clienteRazonSocial,
    subtotal,
    igv,
    total,
    tipoOperacion,
    documentoRelacionado,
    origen,
  });

  const validation = validarDocumentoTributario(documento);
  const docRef = doc(collection(db, CONT_COLLECTIONS.DOCUMENTOS_TRIBUTARIOS));
  const registro = crearRegistroTributario(documento, { tipoRegistro: "VENTA", empresaId: cleanText(empresaId || rucEmpresa), rucEmpresa });
  const registroRef = doc(collection(db, CONT_COLLECTIONS.REGISTROS_TRIBUTARIOS));

  const docPayload = {
    ...documento,
    validacion: validation,
    usuario_registro: cleanText(usuario),
    registro_tributario_id: registroRef.id,
    estado_tributario: validation.ok ? "PENDIENTE_VALIDACION" : "OBSERVADO",
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };

  const regPayload = {
    ...registro,
    validacion_registro: validarRegistroTributario(registro),
    usuario_registro: cleanText(usuario),
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };

  if (transaction) {
    transaction.set(docRef, docPayload);
    transaction.set(registroRef, regPayload);
  } else {
    await setDoc(docRef, docPayload);
    await setDoc(registroRef, regPayload);
  }

  return { documentoId: docRef.id, registroId: registroRef.id, documento, registro };
};

export const registrarDocumentoTributarioCompra = async ({ rucEmpresa, empresaId, origen, comprobante, proveedorRuc, proveedorRazonSocial, subtotal, igv, total, tipoOperacion, documentoRelacionado, usuario }, transaction) => {
  const documento = normalizarDocumentoTributarioCompra({
    empresaId,
    rucEmpresa,
    comprobante,
    proveedorRuc,
    proveedorRazonSocial,
    subtotal,
    igv,
    total,
    tipoOperacion,
    documentoRelacionado,
    origen,
  });

  const validation = validarDocumentoTributario(documento);
  const docRef = doc(collection(db, CONT_COLLECTIONS.DOCUMENTOS_TRIBUTARIOS));
  const registro = crearRegistroTributario(documento, { tipoRegistro: "COMPRA", empresaId: cleanText(empresaId || rucEmpresa), rucEmpresa });
  const registroRef = doc(collection(db, CONT_COLLECTIONS.REGISTROS_TRIBUTARIOS));

  const docPayload = {
    ...documento,
    validacion: validation,
    usuario_registro: cleanText(usuario),
    registro_tributario_id: registroRef.id,
    estado_tributario: validation.ok ? "PENDIENTE_VALIDACION" : "OBSERVADO",
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };

  const regPayload = {
    ...registro,
    validacion_registro: validarRegistroTributario(registro),
    usuario_registro: cleanText(usuario),
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };

  if (transaction) {
    transaction.set(docRef, docPayload);
    transaction.set(registroRef, regPayload);
  } else {
    await setDoc(docRef, docPayload);
    await setDoc(registroRef, regPayload);
  }

  return { documentoId: docRef.id, registroId: registroRef.id, documento, registro };
};

export const obtenerDocumentosTributariosPorEmpresa = async (rucEmpresa) => {
  const q = query(collection(db, CONT_COLLECTIONS.DOCUMENTOS_TRIBUTARIOS), where("ruc_emisor", "==", cleanText(rucEmpresa)));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const obtenerRegistrosTributariosPorEmpresa = async (rucEmpresa) => {
  const q = query(collection(db, CONT_COLLECTIONS.REGISTROS_TRIBUTARIOS), where("ruc_empresa", "==", cleanText(rucEmpresa)));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const obtenerDocumentoTributarioPorOrigen = async ({ tipoOrigen, origenId }) => {
  const q = query(collection(db, CONT_COLLECTIONS.DOCUMENTOS_TRIBUTARIOS), where("origen.tipo", "==", cleanText(tipoOrigen)), where("origen.id", "==", cleanText(origenId)));
  const snap = await getDocs(q);
  return snap.docs[0] ? { id: snap.docs[0].id, ...snap.docs[0].data() } : null;
};
